import "../styles/dashboard.css";
import Box from "@mui/material/Box";
import React from "react";

const Dashboard = () => {
  return (
    <Box sx={{ width: "100%", maxWidth: 360, bgcolor: "background.paper" }}>
      <nav aria-label="main mailbox folders">Dashboard</nav>
    </Box>
  );
};

export default Dashboard;
